export const isGoToContactSales = ({ answers }) => {
  const {
    foodServiceBulkItems,
    alcoholicBeverages,
    displayShippers,
    perishable,
  } = answers;

  return (
    foodServiceBulkItems || alcoholicBeverages || displayShippers || perishable
  );
};
